import AlertResultCount from "./trigger_configs/alert_result_count";

export function loadConfig(name) {
  switch (name) {
    case "alert_result_count":
      return AlertResultCount;
    default:
      return null;
  }
}
